import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  InfoBoardPostDto,
  InfoBoardPostModel,
  GetInfoBoardPostResp,
  GetInfoBoardPostsResp,
} from '../types/info-board'

export const transformInfoBoardPostDto = (dto: InfoBoardPostDto): InfoBoardPostModel => ({
  id: dto.id,
  title: dto.title,
  subtitle: dto.subtitle,
  body: dto.body,
  layoutType: dto.layout_type,
})

export const transformInfoBoardPostDtos = (
  dtos: Array<InfoBoardPostDto>,
): Array<InfoBoardPostModel> => dtos.map(transformInfoBoardPostDto)

export const transformInfoBoardPostResponse = (response: Response<GetInfoBoardPostResp>) =>
  transformInfoBoardPostDto(response.info_post)

export const transformInfoBoardPostsResponse = (response: Response<GetInfoBoardPostsResp>) =>
  transformInfoBoardPostDtos(response.info_posts)
